module.exports = __webpack_public_path__ + "static/media/transportadora.600a98b8.svg";